import { createSlice } from "@reduxjs/toolkit";

export const resellerSlice = createSlice({
  name: "reseller",
  initialState: {
    reseller: [],
    allMikrotikPakages: [],
    resellerCollection: [],
    resellerUsers: [],
    bandwidthPackage: [],
    bandwidthReseller: [],
    bandwidthInvoice: [],
    bandwidthBill: [],
    supportNumber: [],
  },
  reducers: {
    getResellerrSuccess: (state, action) => {
      state.reseller = action.payload;
    },
    addResellerSuccess: (state, action) => {
      state.reseller.push(action.payload);
    },
    editResellerSuccess: (state, action) => {
      state.reseller[
        state.reseller.findIndex((item) => item.id === action.payload.id)
      ] = action.payload;
    },
    editResellerforRecharge: (state, action) => {
      const findR = state.reseller.find(
        (r) => r.id === action.payload.reseller,
      );
      // console.log(findR)
      state.reseller[
        state.reseller.findIndex((item) => item.id === action.payload.reseller)
      ] = {
        ...findR,
        rechargeBalance: findR.rechargeBalance + action.payload.amount,
      };
    },
    deleteResellerSuccess: (state, action) => {
      state.reseller.splice(
        state.reseller.findIndex((item) => item.id === action.payload),
        1,
      );
    },
    clearReseller: (state) => {
      state.reseller = [];
    },
    getAllMikrotikPakages: (state, action) => {
      // console.log(action.payload);
      state.allMikrotikPakages = action.payload;
    },

    //reseller customer collection report action
    getResellerCollectionReport: (state, action) => {
      state.resellerCollection = action.payload;
    },

    //reseller users data action
    getResellerUsersData: (state, action) => {
      state.resellerUsers = action.payload;
    },

    //-------Bandwidth reseller----------//

    createBandwidthPackageSuccess: (state, action) => {
      state.bandwidthPackage.push(action.payload);
    },

    getBandwidthPackageSuccess: (state, action) => {
      state.bandwidthPackage = action.payload;
    },

    updatedBandwidthPackageSuccess: (state, action) => {
      state.bandwidthPackage[
        state.bandwidthPackage.findIndex(
          (item) => item._id === action.payload._id,
        )
      ] = action.payload;
    },

    deleteBandwidthPackageSuccess: (state, action) => {
      state.bandwidthPackage.splice(
        state.bandwidthPackage.findIndex((item) => item.id === action.payload),
        1,
      );
    },

    createBandwidthResellerSuccess: (state, action) => {
      state.bandwidthReseller.push(action.payload);
    },

    updatedBandwidthResellerSuccess: (state, action) => {
      state.bandwidthReseller[
        state.bandwidthReseller.findIndex(
          (item) => item._id === action.payload._id,
        )
      ] = action.payload;
    },

    deleteBandwidthResellerSuccess: (state, action) => {
      state.bandwidthReseller.splice(
        state.bandwidthReseller.findIndex((item) => item.id === action.payload),
        1,
      );
    },

    getBandwidthResellerSuccess: (state, action) => {
      state.bandwidthReseller = action.payload;
    },

    createBandwidthSaleInvoiceSuccess: (state, action) => {
      state.bandwidthInvoice.push(action.payload);
    },

    updatedBandwidthSaleInvoiceSuccess: (state, action) => {
      state.bandwidthInvoice[
        state.bandwidthInvoice.findIndex(
          (item) => item._id === action.payload._id,
        )
      ] = action.payload;
    },

    getBandwidthSaleInvoiceSuccess: (state, action) => {
      state.bandwidthInvoice = action.payload;
    },

    createBandwidthBillReportSuccess: (state, action) => {
      state.bandwidthBill.push(action.payload);
    },

    getBandwidthBillReportSuccess: (state, action) => {
      state.bandwidthBill = action.payload;
    },

    //--- Reseller Support Number ---//
    getResellerSupportNumbersSuccess: (state, action) => {
      state.supportNumber = action.payload;
    },
    createResellerSupportNumbersSuccess: (state, action) => {
      state.supportNumber.push(action.payload);
    },
    updatedResellerSupportNumbersSuccess: (state, action) => {
      state.supportNumber[
        state.supportNumber.findIndex((item) => item.id === action.payload.id)
      ] = action.payload;
    },
    deleteResellerSupportNumbersSuccess: (state, action) => {
      state.supportNumber.splice(
        state.supportNumber.findIndex((item) => item.id === action.payload),
        1,
      );
    },
  },
});
export const {
  getResellerrSuccess,
  addResellerSuccess,
  editResellerSuccess,
  deleteResellerSuccess,
  editResellerforRecharge,
  clearReseller,
  getResellerUsersData,
  getAllMikrotikPakages,
  getResellerCollectionReport,
  createBandwidthPackageSuccess,
  getBandwidthPackageSuccess,
  updatedBandwidthPackageSuccess,
  deleteBandwidthPackageSuccess,
  createBandwidthResellerSuccess,
  updatedBandwidthResellerSuccess,
  deleteBandwidthResellerSuccess,
  getBandwidthResellerSuccess,
  createBandwidthSaleInvoiceSuccess,
  updatedBandwidthSaleInvoiceSuccess,
  getBandwidthSaleInvoiceSuccess,
  createBandwidthBillReportSuccess,
  getBandwidthBillReportSuccess,
  getResellerSupportNumbersSuccess,
  createResellerSupportNumbersSuccess,
  updatedResellerSupportNumbersSuccess,
  deleteResellerSupportNumbersSuccess,
} = resellerSlice.actions;

export default resellerSlice.reducer;
